import { AppSettingsState } from 'app/store/appSettings/AppSettingsState';
import State from 'store/State';
import { StrategyParamsChannelDestinations } from 'widgets/strategyParams/store/stream/stream-config';
import { OrderIdsStreamRequest } from 'communication/types/order/OrderIdsStreamRequest';
import { toOrderIdsStreamRequest } from 'widgets/streaming/OrderIdsStreamRequest';
import { PortfolioSelectionWrapper } from 'portfolio/PortfolioSelectionWrapper';

export function createSingleOrderRequest(
    orderIds: string[]
): OrderIdsStreamRequest | undefined {
    return orderIds.length === 1
        ? toOrderIdsStreamRequest(orderIds)
        : undefined;
}

export function createMultipleOrderRequest(
    orderIds: string[]
): OrderIdsStreamRequest | undefined {
    return orderIds.length > 1 ? toOrderIdsStreamRequest(orderIds) : undefined;
}

export function createStrategyParametersStreamRequest(
    channelDestination: StrategyParamsChannelDestinations
): (
    orderIds: string[],
    portfolioSelection: PortfolioSelectionWrapper,
    widgetKey: string,
    appSettings: AppSettingsState,
    state: State
) => OrderIdsStreamRequest | undefined {
    return (
        orderIds,
        _portfolioSelection: PortfolioSelectionWrapper,
        _widgetKey,
        _appSettings,
        _state
    ) => {
        return channelDestination === 'startStrategyParamsHistByOrderIdsStream'
            ? createSingleOrderRequest(orderIds)
            : createMultipleOrderRequest(orderIds);
    };
}
